module.exports = __webpack_public_path__ + "audio/twelveAudio.f491d9d2.mp3";